
import {FC} from "react";

import React from 'react';

import MLAApprovalForm from "../../forms/ppap/mla-approval-form";

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

interface Interface{
    requestId: any;
    mode?: "Edit" | "Add new";
    onClose?: () => void;
}

const MLAApprovalScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <MLAApprovalForm
                    requestId={props.requestId}
                />
            
    );
}
export default MLAApprovalScreen;
